import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://673626f21d1f3902b792644ca7bac66e@o4511070359388160.ingest.us.sentry.io/4511070367776768",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});